import React, { useState, useEffect } from 'react';
import styles from "./asesores.module.css";
import { IoCloseSharp } from "react-icons/io5";
import Swal from 'sweetalert2';
import { api } from '../../utils/services/api';
import { FUNTIONS, SERVICE } from '../../utils/constants/services';
import Select from 'react-select'

export default function ModalAsesores(props) {
    const { show, setShow, dataEdit, setDataEdit, municipios, estados, codigos, ofices, coordinadores, handleUpdate } = props;
    const [name, setName] = useState("");
    const [direccion, setDireccion] = useState("");
    const [alias, setAlias] = useState("");
    const [phone, setPhone] = useState("");
    const [direccionDetalle, setDireccionDetalle] = useState("");
    const [dateBirth, setDateBirth] = useState("");
    const [admissionDate, setAdmissionDate] = useState("");
    const [update, setUpdate] = useState(true);

    const [stateSelect, setStateSelect] = useState(null);
    const [municipalFilter, setMunicipalFilter] = useState([]);
    const [municipalSelect, setMunicipalSelect] = useState(null);

    const [postalCodeFilter, setPostalCodeFilter] = useState([]);
    const [postalCodeSelect, setPostalCodeSelect] = useState(null);

    const [oficesSelect, setOficesSelect] = useState(null);
    const [coordinadorSelect, setCoordinadorSelect] = useState(null);

    const [active, setActive] = useState(true);
    const [edad, setEdad] = useState(0);

    const handleAgregar = () => {
        if (name === "" || alias === "" || direccion === "" || phone === "" || direccionDetalle === "" || dateBirth === "" || stateSelect === null || municipalSelect === null || postalCodeSelect === null || oficesSelect === null || coordinadorSelect === null) {
            Swal.fire({
                text: 'Favor de llenar todos los campos',
                icon: 'error',
                confirmButtonText: 'Aceptar'
            })
        }
        else {
            if (dataEdit != null) {
                let payload = {
                    id: dataEdit.id,
                    completeName: name,
                    alias: alias,
                    centralOfficeId: oficesSelect.value,
                    stateId: stateSelect.value,
                    municipalityId: municipalSelect.value,
                    postalCodeId: postalCodeSelect.value,
                    address: direccion,
                    phoneNumber: phone,
                    dateOfBirth: dateBirth,
                    addressDescription: direccionDetalle,
                    coordinatorId: coordinadorSelect.value,
                    status: true,
                    admissionDate: admissionDate
                }
                api(SERVICE.updateAsesores, payload, "PUT")
                    .then((data) => {
                        let response = data.data;
                        if (response.status) {
                            handleUpdate();
                            setShow(false);
                            Swal.fire({
                                position: "center",
                                icon: "success",
                                title: "Guardado correctamente",
                                showConfirmButton: false,
                                timer: 1500
                            });
                        }
                        else {
                            Swal.fire({
                                title: response.generalMessage,
                                icon: 'error',
                                confirmButtonText: 'Aceptar'
                            })
                        }

                    })
                    .catch((err) => {
                        console.log(err);
                    })
            }
            else {
                let payload = {
                    completeName: name,
                    alias: alias,
                    centralOfficeId: oficesSelect.value,
                    stateId: stateSelect.value,
                    municipalityId: municipalSelect.value,
                    postalCodeId: postalCodeSelect.value,
                    address: direccion,
                    phoneNumber: phone,
                    dateOfBirth: dateBirth,
                    addressDescription: direccionDetalle,
                    coordinatorId: coordinadorSelect.value,
                    status: true,
                    admissionDate: admissionDate
                }
                api(SERVICE.setAsesores, payload, "POST")
                    .then((data) => {
                        let response = data.data;
                        if (response.status) {
                            handleUpdate();
                            setShow(false);
                            Swal.fire({
                                position: "center",
                                icon: "success",
                                title: "Guardado correctamente",
                                showConfirmButton: false,
                                timer: 1500
                            });
                        }
                        else {
                            Swal.fire({
                                title: response.generalMessage,
                                icon: 'error',
                                confirmButtonText: 'Aceptar'
                            })
                        }

                    })
                    .catch((err) => {
                        console.log(err);
                    })
            }

        }

    }


    useEffect(() => {
        if (stateSelect != null && municipios && municipios.length > 0 && update) {
            if (!update)
                setMunicipalSelect(null);
            let ArrayTemp = [];
            for (let index = 0; index < municipios.length; index++) {
                const element = municipios[index];
                if (element.stateId === stateSelect.value) {
                    ArrayTemp.push(element);
                }

            }
            setMunicipalFilter(ArrayTemp);
        }
    }, [stateSelect, municipios])
    useEffect(() => {
        if (stateSelect != null && municipalSelect != null && codigos && codigos.length > 0 && update) {
            if (!update)
                setPostalCodeSelect(null);
            let ArrayTemp = [];
            for (let index = 0; index < codigos.length; index++) {
                const element = codigos[index];
                if (element.stateId === stateSelect.value && element.municipalityId === municipalSelect.value) {
                    ArrayTemp.push(element);
                }

            }
            setPostalCodeFilter(ArrayTemp);
        }

    }, [stateSelect, municipalSelect, codigos, ofices])

    useEffect(() => {
        if (!show) {
            setName("");
            setDireccion("");
            setPhone("");
            setDireccionDetalle("");
            setDateBirth("");
            setAlias("");
            setAdmissionDate("");

            setStateSelect(null);
            setMunicipalSelect(null);
            setPostalCodeSelect(null);
            setOficesSelect(null);
            setDataEdit(null);
            setCoordinadorSelect(null)
        }
    }, [show])
    useEffect(() => {
        if (dataEdit != null) {
            setUpdate(true);
            const formattedDate2 = dataEdit.admissionDate ? dataEdit.admissionDate.split("T")[0] : "";
            setAdmissionDate(formattedDate2);
            setName(dataEdit.completeName);
            setDireccion(dataEdit.address);
            setDireccionDetalle(dataEdit.addressDescription);
            setPhone(dataEdit.phoneNumber);
            setAlias(dataEdit.alias);
            const formattedDate =  dataEdit.dateOfBirth ? dataEdit.dateOfBirth.split("T")[0] : "";
            setDateBirth(formattedDate);
            setStateSelect({
                value: dataEdit.stateId,
                label: dataEdit.stateName
            });
            setMunicipalSelect({
                value: dataEdit.municipalityId,
                label: dataEdit.municipalityName,
                stateId: dataEdit.stateId
            });
            setPostalCodeSelect({
                value: dataEdit.postalCodeId,
                label: dataEdit.postalCodeName,
                stateId: dataEdit.stateId,
                municipalityId: dataEdit.municipalityId
            });
            setOficesSelect({
                value: dataEdit.centralOfficeId,
                label: dataEdit.centralOfficeName,
            });
            setCoordinadorSelect({
                value: dataEdit.coordinatorId,
                label: dataEdit.coordinatorName,
            });
            setTimeout(() => {
                setUpdate(false);
            }, 1000);
        }
    }, [dataEdit])
    useEffect(() => {
        if (dateBirth !== "") {
            setEdad(FUNTIONS.calculateAge(dateBirth));
        }
    }, [dateBirth])
    return (
        <>
            <div className={styles.bodyModal} style={{ display: show ? "" : "none" }}>
                <div className={`${styles.containerFormMain} animate__animated animate__fadeInDown`} style={{ display: show ? "" : "none" }}>
                    <div className={styles.headerForm}>
                        <h5>{dataEdit != null ? "Editar asesor" : "Nuevo asesor"}</h5>
                        <div className={styles.icon} onClick={() => setShow(false)}>
                            <IoCloseSharp />
                        </div>

                    </div>

                    <div className={styles.containerForm}>
                        <div className={styles.itemForm} style={{ width: "65%" }}>
                            <label className="form-label">Nombre completo</label>
                            <input type="text" className="form-control" placeholder="Nombre" value={name} onChange={(e) => setName(e.target.value)} />
                        </div>
                        <div className={styles.itemForm} style={{ width: "35%" }}>
                            <label className="form-label">Sucursal</label>
                            <div className={styles.selectContainer}>
                                <Select
                                    options={ofices}
                                    value={oficesSelect}
                                    onChange={(e) => setOficesSelect(e)}
                                    placeholder="Seleccionar sucursal..."
                                />
                            </div>
                        </div>
                        <div className={styles.itemForm} style={{ width: "40%" }}>
                            <label className="form-label">Alias</label>
                            <input type="text" className="form-control" placeholder="Alias" value={alias} onChange={(e) => setAlias(e.target.value)} />
                        </div>
                        <div className={styles.itemForm} style={{ width: "60%" }}>
                            <label className="form-label">Coordinador</label>
                            <div className={styles.selectContainer}>
                                <Select
                                    options={coordinadores}
                                    value={coordinadorSelect}
                                    onChange={(e) => setCoordinadorSelect(e)}
                                    placeholder="Seleccionar coordinador..."
                                />
                            </div>
                        </div>
                        <div className={styles.itemForm} style={{ width: "40%" }}>
                            <label className="form-label">Estado</label>
                            <div className={styles.selectContainer}>
                                <Select
                                    options={estados}
                                    value={stateSelect}
                                    onChange={(e) => setStateSelect(e)}
                                    placeholder="Seleccionar estado..."
                                />
                            </div>
                        </div>
                        <div className={styles.itemForm} style={{ width: "60%" }}>
                            <label className="form-label">Municipio</label>
                            <div className={styles.selectContainer}>
                                <Select
                                    options={municipalFilter}
                                    value={municipalSelect}
                                    onChange={(e) => setMunicipalSelect(e)}
                                    placeholder="Seleccionar municipio..."
                                />
                            </div>
                        </div>
                        <div className={styles.itemForm} style={{ width: "65%" }}>
                            <label className="form-label">Código Postal</label>
                            <div className={styles.selectContainer}>
                                <Select
                                    options={postalCodeFilter}
                                    value={postalCodeSelect}
                                    onChange={(e) => setPostalCodeSelect(e)}
                                    placeholder="Seleccionar código postal..."
                                />
                            </div>
                        </div>
                        <div className={styles.itemForm} style={{ width: "35%" }}>
                            <label className="form-label">Número de teléfono</label>
                            <input type="text" className="form-control" placeholder="1234567890" value={phone} onChange={(e) => setPhone(e.target.value)} />
                        </div>

                        <div className={styles.itemForm} style={{ width: "100%" }}>
                            <label className="form-label">Domicilio</label>
                            <input type="text" className="form-control" placeholder="Domicilio" value={direccion} onChange={(e) => setDireccion(e.target.value)} />
                        </div>
                        <div className={styles.itemForm} style={{ width: "100%" }}>
                            <label className="form-label">Referencias (Entre calles)</label>
                            <input type="text" className="form-control" placeholder="Referencias (entre calles)" value={direccionDetalle} onChange={(e) => setDireccionDetalle(e.target.value)} />
                        </div>
                        <div className={styles.itemForm} style={{ width: "35%" }}>
                            <label className="form-label">Fecha de ingreso</label>
                            <input type="date" data-date-format="DD MMMM YYYY" className="form-control" placeholder="" value={admissionDate} onChange={(e) => setAdmissionDate(e.target.value)} />
                        </div>
                        <div className={styles.itemForm} style={{ width: "32%" }}>
                            <label className="form-label">Fecha de nacimiento</label>
                            <input type="date" data-date-format="DD MMMM YYYY" className="form-control" placeholder="" value={dateBirth} onChange={(e) => setDateBirth(e.target.value)} />
                        </div>
                        <div className={styles.itemForm} style={{ width: "18%" }}>
                            <label className="form-label">Edad</label>
                            <input type="text" readOnly value={edad} className="form-control" placeholder="" />
                        </div>
                       
                        <div className={styles.itemForm} style={{ width: "35%" }}>
                            <div className={styles.checkboxContainer}>
                                <input 
                                    className="form-check-input" 
                                    type="checkbox" 
                                    role="switch" 
                                    id="switchCheckChecked" 
                                    checked={active} 
                                    onChange={() => setActive(!active)} 
                                />
                                <label 
                                    className="form-check-label" 
                                    htmlFor="switchCheckChecked" 
                                    style={{ fontWeight: "bold", color: active ? "green" : "red" }}
                                >
                                    {active ? "Activo" : "Inactivo"}
                                </label>
                            </div>
                        </div>









                    </div>
                    <div className={styles.containerBtn}>
                        <button className='btn btn-success' onClick={handleAgregar}>{dataEdit != null ? "Editar" : "Crear"}</button>&nbsp;&nbsp;
                        <button className='btn btn-danger' onClick={() => setShow(false)}>Cancelar</button>
                    </div>
                </div>
            </div>
        </>
    );
}